// Only the component styles that provide real value over inline Tailwind

// Campaign status colors - Maps business logic to styles (with dark mode support)
export const statusColors = {
  draft: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  scheduled: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  sending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  cancelled: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
} as const;

// Complex input styles that would be verbose inline
export const inputBase = [
  'block w-full rounded-md border-0 py-1.5 px-3',
  'text-gray-900 dark:text-gray-100',
  'bg-white dark:bg-gray-800',
  'shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600',
  'placeholder:text-gray-400 dark:placeholder:text-gray-500',
  'focus:ring-2 focus:ring-inset focus:ring-primary-600 dark:focus:ring-primary-500',
  'sm:text-sm sm:leading-6',
  'disabled:cursor-not-allowed disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-500 dark:disabled:text-gray-400',
  'transition-colors duration-200'
].join(' ');

// Button variants for consistency across the app
export const buttonVariants = {
  primary: 'bg-primary-600 text-white hover:bg-primary-700 focus:ring-primary-500 dark:bg-primary-500 dark:hover:bg-primary-600',
  secondary: 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 focus:ring-primary-500',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 dark:bg-red-500 dark:hover:bg-red-600',
  ghost: 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 focus:ring-gray-500',
} as const;

export const buttonSizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
  xl: 'px-8 py-4 text-lg',
} as const;

// Badge styles
export const badgeBase = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

export const badgeVariants = {
  default: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  gray: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  red: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  green: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  indigo: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200',
  purple: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  pink: 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200',
} as const;

// Card styles
export const cardStyles = {
  base: 'bg-white dark:bg-gray-800 shadow dark:shadow-gray-900 rounded-lg',
  bordered: 'bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg',
  hover: 'bg-white dark:bg-gray-800 shadow dark:shadow-gray-900 rounded-lg hover:shadow-lg dark:hover:shadow-gray-900 transition-shadow',
} as const;

// Reusable input styles
export const inputStyles = {
  base: inputBase,
  error: inputBase + ' ring-red-500 dark:ring-red-400 focus:ring-red-500 dark:focus:ring-red-400',
  success: inputBase + ' ring-green-500 dark:ring-green-400 focus:ring-green-500 dark:focus:ring-green-400',
} as const;
